module.exports = __webpack_public_path__ + "img/7.25241d6a.png";